import { render, staticRenderFns } from "./currencyDisplay.vue?vue&type=template&id=dd640a78&scoped=true&"
import script from "./currencyDisplay.vue?vue&type=script&lang=js&"
export * from "./currencyDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd640a78",
  null
  
)

export default component.exports